import { Resources } from 'constants/resources';

import { useQuery } from '@tanstack/react-query';
import { CumulativeReportResponse, getCumulativeReport } from 'config/requests/cumulativeReport';
import { CumulativeReportFilterValues } from 'pages/Finance/CumulativeReport/CumulativeReportFilter';

type UseGetCumulativeReportReturnValue = {
  cumulativeReport: CumulativeReportResponse | undefined;
  isLoading: boolean;
};

export function useGetCumulativeReport(
  filters: CumulativeReportFilterValues,
): UseGetCumulativeReportReturnValue {
  const { data: cumulativeReport, isLoading } = useQuery<CumulativeReportResponse>({
    queryKey: [
      Resources.CumulativeReport,
      filters.periodTo,
      filters.periodFrom,
      filters.accountsSummary,
      filters.currency,
      filters.merchantAccounts,
      filters.merchant,
      filters.provider,
    ],
    queryFn: () => getCumulativeReport(filters),
    enabled: Object.keys(filters).length > 0,
  });

  return { cumulativeReport, isLoading };
}
